import React, {useContext} from "react" ;
import AppBodyNotificationDropdown from "root/Wieldy/ApplicationModules/Common/Body/AppBodyNotificationDropdown";
import {LetterBoxFilter, LetterBoxMenuTitles, PostFilters, UserTypeTitles} from "root/DataFunctions/Constants";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import {ApplicationTypes, doesUserHaveApplication} from "root/DataFunctions/PageContentRoles";
import GlobalContext from "root/contexts/GlobalContext";

const LetterboxAppBodyHeader= (props) =>
{
    const {search} = useLocation();
    const queryParams = queryString.parse(search);
    const { pathname }  = useLocation();
    const globals = useContext(GlobalContext);
    const shouldShowToApprove = doesUserHaveApplication(ApplicationTypes.POSTBOX_APPROVER, globals.userType)  ;
    const defaultHeader = shouldShowToApprove ? LetterBoxMenuTitles.UNAPPROVED: LetterBoxMenuTitles.APPROVED ;

    const buildHeader = (sub_header) =>{
        const header = <h4 className="title">{sub_header}</h4>;
        return header;
    }

    const displayHeader = () =>
    {
        if(queryParams.type !== undefined)
        {
            switch (queryParams.type)
            {
                case LetterBoxFilter.UNAPPROVED:
                    const notApprovedHeader = shouldShowToApprove ? LetterBoxMenuTitles.UNAPPROVED : 'Waiting Approval';
                    return buildHeader(notApprovedHeader);
                    break;

                case LetterBoxFilter.RETURNED_BY_LETTERBOX:
                    return buildHeader(LetterBoxMenuTitles.RETURNED);
                    break;

                case LetterBoxFilter.APPROVED:
                    return buildHeader('Approved');
                    break;

                case LetterBoxFilter.NOT_APPROVED:
                    return buildHeader(LetterBoxMenuTitles.NOT_APPROVED);
                    break;

                case LetterBoxFilter.TO_SEND_ON:
                    return buildHeader(LetterBoxMenuTitles.APPROVED);
                    break;

                case LetterBoxFilter.ALL:
                    return buildHeader('All');
                    break;

                default:
                    return buildHeader(defaultHeader);
                    break;
            }
        }
        else if(pathname.includes('/letterbox/letterbox')){
            return buildHeader(defaultHeader);
        }
        else if(pathname.includes('/letterbox/calendar')){
            //Default to details
            return buildHeader('Calendar');
        }
        else{
            return buildHeader(defaultHeader);
        }
    }

    return (
        <div className="dt-module__header d-none d-md-flex">

            <div className="child-menu-item">
                {displayHeader()}
            </div>
            {/*<AppBodyNotificationDropdown />*/}

        </div>
    ) ;
}

export default LetterboxAppBodyHeader;
